import moment from "moment";

moment.locale("en-gb", {
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    }
});

moment.locale(window.navigator.userLanguage || window.navigator.language)

// Export filters for Vue 3 (filters were removed in Vue 3)
export const filters = {
    calendar(value) {
        return moment(value).calendar();
    },
    long(value) {
        return moment(value).format("LLL");
    },
    short(value) {
        return moment(value).format("L");
    },
    log(value) {
        return moment(value).format("YYYY-MM-DD HH:mm:ss.SSS")
    }
};